import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import { BrowserRouter as Router } from 'react-router-dom';
import Quill from 'quill';

import App from './App';

import reportWebVitals from './reportWebVitals';

import DipClient from './dip/DipClient';
import DataManager from './dip/DataManager';
import Content from './content/Content';

import ExternalAppInterface from './ExternalAppInterface';

const run = async () => {
	let font = Quill.import('attributors/style/font');
	font.whitelist = undefined;
	Quill.register(font, true);

	let fontSize = Quill.import('attributors/style/size');
	fontSize.whitelist = undefined;
	Quill.register(fontSize, true);

	//console.log("Quill.imports = " + JSON.stringify(Quill.imports));

	const Parchment = Quill.import('parchment');
	const lineHeightCfg = {
		scope: Parchment.Scope.INLINE,
		//whitelist: lineHeights
	};
	const lineHeightStyle = new Parchment.Attributor.Style('lineheight', 'line-height', lineHeightCfg);
	Quill.register(lineHeightStyle, true);

	global.queryParams = new URLSearchParams(window.location.search);

	// initializes DIP client and Data Manager
	//
	global.dipClient = new DipClient(process.env.REACT_APP_ENV_KEY);
	global.dataManager = new DataManager();

	let authToken = global.queryParams.get('authToken');
	if (authToken) {
		global.dipClient.setAuthInfo(authToken);
	}
	// TOOD: temporary code for testing
	//await global.dipClient.login("madincom@naver.com", "1111");

	// initializes the content to edit
	//
	global.content = new Content();

	let id = global.queryParams.get('id');
	let qr = global.queryParams.get('qr');
	let app = global.queryParams.get('app');

	if (id) {
		await global.content.load({ id: id });
	}
	else if (qr) {
		await global.content.load({ qr: qr });
	}
	else if (app) {
		await global.content.load({ app: app });
	}
	else {
		await global.content.preload(
			global.queryParams.get('category'),
			global.queryParams.get('templateId'),
			global.queryParams.get('blockType')
		);
	}

	// TODO: temporary for testing
	//if (global.content.isLocked) {
	//	await global.content.unlock({ password: "1234" });
	//}

	global.extAppInterface = new ExternalAppInterface();
	global.extAppInterface.init();

	ReactDOM.render(
		<React.StrictMode>
			<Router>
				<App />
			</Router>
		</React.StrictMode>,
		document.getElementById('root')
	);

	// If you want to start measuring performance in your app, pass a function
	// to log results (for example: reportWebVitals(console.log))
	// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
	reportWebVitals();
};

run();
